import { StyleSheet } from 'react-native'
import { colorList } from 'utils/colors'

export const ModalStyles = StyleSheet.create( {
	background: {
		position:'absolute',
		top:0,
		left:0,
		right:0,
		bottom:0,
		backgroundColor: colorList.WHITE.primary
	},
	container: {
		zIndex: 1000,
		position: 'absolute',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
		width: '100%',
		height: '100%',
		backgroundColor: 'rgba(0,0,0,0.5)',
		justifyContent: 'center',
		alignItems: 'center',
	},
});